<template>
  <v-container class="pt-10">

    <v-row v-if="!collection.id">
      <v-col>
        <v-skeleton-loader
          type="list-item-avatar-three-line"
        ></v-skeleton-loader>
      </v-col>
    </v-row>

    <v-row class="pb-10" v-else>

      <v-col class="px-10" align-self="center">

        <div class="text-center">
          <p class="text-h2 font-weight-bold">
            {{ collection.name }}
          </p>
        </div>

      </v-col>

    </v-row>

    <!-- libraries -->
    <div v-if="collection.hasLibraries">
      
      <Grid :items="collection.sortedLibraries"
            class="mt-10 pb-10"
            @click="onLibraryClick"/>

    </div>

  </v-container>
</template>

<script>
import API from '@/api'

import { mapMutations } from 'vuex'

import slug from '@/mixins/slug'
import utility from '@/mixins/utility'

import Grid from '@/components/Grids/Simple'

export default {
  
  name: 'Collection',

  mixins: [ slug, utility ],

  components:
  {
    Grid
  },

  data: () => ({
    collection: {}
  }),

  computed:
  {
    
  },

  methods: 
  {
    ...mapMutations({
      setLoading: 'ui/setLoading'
    }),

    onLibraryClick(library)
    {
      let params = { slug:library.slug, library:library }

      this.goTo({ name:'library', params })
    },

    load()
    {
      if( this.$route.params.collection )
        this.collection = this.$route.params.collection

      if( !this.slug )
        return
      
      this.setLoading('linear')

      API.collection.one(this.slug, { include:'libraries' })
                 .then(({ data })=>{

                  this.collection = this.mapModel(data.data, 'collection')

                 })
                 .finally(()=>this.setLoading(false))
    },
  },

  mounted()
  {
    this.load()

    this.setBack('home')
  },

  watch:
  {
    
  }

}
</script>
